module.exports = __webpack_public_path__ + "static/media/location_icon.c8023bcc.svg";